import React from 'react';
import styled from 'styled-components';

export default function ClusterBadgeTag({ color, children, size = 'normal' }) {
  if (size === 'small') {
    return <SmallRoot backgroundColor={color}>{children}</SmallRoot>;
  }
  return <Root backgroundColor={color}>{children}</Root>;
}

const Root = styled.div`
  position: absolute;
  background-color: ${(props) => props.backgroundColor};
  display: flex;
  align-items: flex-end;
  -webkit-box-pack: center;
  justify-content: center;
  transform: rotate(45deg);
  width: 58px;
  height: 58px;
  right: -29px;
  top: -29px;
  color: white;
  font-size: 12px;
  padding-left: 2px;
`;

const SmallRoot = styled.div`
  position: absolute;
  background-color: ${(props) => props.backgroundColor};
  display: flex;
  align-items: flex-end;
  -webkit-box-pack: center;
  justify-content: center;
  transform: rotate(45deg) scale(0.8);
  width: 98px;
  height: 66px;
  right: -48px;
  top: -31px;
  color: white;
  font-size: 16px;
  box-sizing: border-box;
  padding: 0px 29px 2px;
  line-height: 1.5em;
`;
